import React from 'react';
import { Button } from 'react-admin';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Tooltip from '@material-ui/core/Tooltip';
import cx from 'classnames';

import ForkIcon from '@material-ui/icons/CallSplit';

const useStyles = makeStyles((theme) => ({
  red: {
    color: theme.palette.error.main,
  },
  yellow: {
    color: theme.palette.warning.main,
  },
}));
interface Props {
  onClick?: () => void;
  red?: boolean;
  yellow?: boolean;
  label: string;
  disabled?: boolean;
  tooltip?: string;
  [x: string]: any;
}

const ForkButton = (props: Props) => {
  const { onClick, className, red, yellow, label, disabled, tooltip, ...rest } = props;
  const classes = useStyles();

  const button = (
    <Button
      label={label}
      onClick={onClick}
      disabled={disabled}
      className={cx(
        { [classes.red]: red && !disabled, [classes.yellow]: yellow && !disabled },
        className
      )}
      {...rest}
    >
      <ForkIcon />
    </Button>
  );

  if (tooltip) {
    return (
      <Tooltip title={tooltip}>
        <span>{button}</span>
      </Tooltip>
    );
  }
  return button;
};

export default ForkButton;
